(function(){
  'use strict';

  // Default to solid header on pages without a dark hero (i.e. PDP, account, etc.)
  if (!document.getElementById('hero')) document.body.classList.add('header-solid');

  /* PDP Routines picker reload → reopen cart drawer. The picker ATC forces
     a full page reload after Add To Cart to reset stale checkbox / CTA
     state; this hook checks the sessionStorage flag on the next load and
     dispatches the drawer-open event so the customer still lands on their
     bag. Runs on every page load — no-op unless the flag is set. */
  try {
    if (sessionStorage.getItem('pnm_open_cart_on_load') === '1') {
      sessionStorage.removeItem('pnm_open_cart_on_load');
      window.setTimeout(function () {
        try {
          document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
          var drawer = document.getElementById('cart-drawer');
          if (drawer) drawer.classList.add('active');
        } catch (e) {}
      }, 200);
    }
  } catch (e) {}

  // Rotating util-bar messages
  (function(){
    var msgs = document.querySelectorAll('#rotating-msgs .rot-msg');
    if (!msgs.length) return;
    var idx = 0;
    setInterval(function(){ msgs[idx].classList.remove('active'); idx = (idx + 1) % msgs.length; msgs[idx].classList.add('active'); }, 4000);
  })();

  // Auto-tag PDP section headings with data-reveal so every block animates
  // the same way the homepage and rewards page do — without touching 23 sections by hand.
  document.querySelectorAll(
    '.site > section .head, ' +
    '.site > section > h2, ' +
    '.site > section > h3, ' +
    '.site > section > .ey, ' +
    '.site > section > .eyebrow, ' +
    '.s-10 .text, .s-11 .stats, .s-12 .grid, .s-13 .steps, ' +
    '.s-14 .routine, .s-15 .bundle, .s-17 .grid, .s-19 .acc, ' +
    '.s-21 .logos, .s-22 .text'
  ).forEach(function(el){
    if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
  });

  // Scroll-reveal — same observer config as homepage
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-in'); });
  }

  // Gallery thumbnail click → slide-in-from-right swap
  (function(){
    var rail = document.getElementById('gallery-rail');
    var main = document.getElementById('gallery-main');
    if (!rail || !main) return;
    rail.addEventListener('click', function(e){
      var thumb = e.target.closest('.thumb');
      if (!thumb || thumb.classList.contains('video')) return;
      var src = thumb.dataset.img;
      if (!src || src === main.src) return;
      rail.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('on'); });
      thumb.classList.add('on');
      // Remove animation class, swap src, force reflow, re-add to retrigger
      main.classList.remove('is-swapping');
      void main.offsetWidth;
      main.src = src;
      main.classList.add('is-swapping');
    });
  })();

  // ---------- Metafield preview toggle (design QA only) ----------
  // In production these toggles are replaced by Liquid conditionals reading
  // `product.metafields.custom.show_routines` and
  // `product.metafields.custom.show_better_together`.
  document.querySelectorAll('.meta-preview [data-meta-toggle]').forEach(function(input){
    input.addEventListener('change', function(){
      var key = input.dataset.metaToggle;
      if (key === 'show_routines') {
        document.body.classList.toggle('hide-routines', !input.checked);
      } else if (key === 'show_better_together') {
        document.body.classList.toggle('hide-better-together', !input.checked);
      }
    });
  });

  // Sticky add-to-cart bar — triggers when the hero scrolls out of view.
  // Queries by class so both the default sticky (#sec-23) and the v3
  // variant (#sec-23-v3) toggle together; whichever is placed on the
  // template will show.
  // Hero element the IntersectionObserver watches to toggle `.s-23.show`.
  //   - #hero-block           → pdp-v2-hero / pdp-v3-hero
  //   - [data-pdp-hero-split] → pdp-v3-hero-split (used by pdp-v7)
  //   - .pdp-v3-hs            → last-resort fallback for the split hero
  var heroBlock  = document.getElementById('hero-block')
                || document.querySelector('[data-pdp-hero-split]')
                || document.querySelector('.pdp-v3-hs');
  var stickyBars = document.querySelectorAll('.s-23');
  if (heroBlock && stickyBars.length && 'IntersectionObserver' in window) {
    var heroObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var show = entry.intersectionRatio < 0.2;
        stickyBars.forEach(function(bar){
          if (show) bar.classList.add('show');
          else bar.classList.remove('show');
        });
      });
    }, { threshold: [0, 0.2, 0.5, 1] });
    heroObserver.observe(heroBlock);
  }

  // -----------------------------------------------------------------
  // SHOPIFY SUBSCRIPTIONS — Subscribe & Save / One-time picker
  // -----------------------------------------------------------------
  // Clicking either card toggles `.on`. Selecting SUBSCRIBE fills the
  // hidden `selling_plan` input with the active frequency's plan ID
  // and recomputes the displayed price, +pts line, and Klarna split
  // from the discount %. ONE-TIME clears the plan and shows base price.
  //
  // Production note: replace the hard-coded data-discount values with
  // {{ plan.price_adjustments[0].value }} when rendering from Liquid.
  // -----------------------------------------------------------------
  (function(){
    var form     = document.getElementById('bb-form');
    if (!form) return;
    var basePrice = parseFloat(form.dataset.basePrice || '25.00');
    var compareAt = parseFloat(form.dataset.compareAtPrice || form.dataset.basePrice || '0');
    var currency  = form.dataset.currency || '€';

    function fmt(n){ return currency + n.toFixed(2); }

    // Re-query everything on each refresh so the handler always targets the
    // LIVE DOM — the Subscriptions app / cart-add flow can replace nodes and
    // any cached reference from page-load becomes an orphan.
    function refresh(){
      var hiddenPlan     = document.getElementById('current-plan');
      var freqSelect     = document.getElementById('bb-freq');
      var pointsEl       = form.querySelector('.js-points');
      var klarnaEl       = form.querySelector('.js-klarna');
      var subPriceEls    = form.querySelectorAll('.js-sub-price');
      var currentPriceEls = document.querySelectorAll('.js-current-price');
      var wasPriceEls    = document.querySelectorAll('.js-was-price');
      var subDiscountEl  = form.querySelector('.js-discount');
      var subCard        = form.querySelector('.card[data-mode="subscribe"]');

      var activeCard = form.querySelector('.bb-commit .card.on');
      /* Default to 'onetime' if no subscribe card exists (product has no selling plan).
         Otherwise default to 'subscribe' when a sub card exists but isn't yet .on. */
      var mode = activeCard ? activeCard.dataset.mode : (subCard ? 'subscribe' : 'onetime');
      var discount = 0;
      var effectivePrice = basePrice;
      var planId = '';

      if (mode === 'subscribe') {
        // Read the active frequency option for its discount + plan ID
        var opt = freqSelect && freqSelect.options[freqSelect.selectedIndex];
        var fallbackPct = subCard ? subCard.dataset.discount : '15';
        discount = opt ? parseFloat(opt.dataset.discount || fallbackPct || '15') : parseFloat(fallbackPct || '15');
        planId   = opt ? opt.value : '';
        // Apply the subscribe discount to the ORIGINAL price (compare_at) when the
        // variant is on sale — never stack sub % on top of the sale discount.
        // Falls back to basePrice when there's no compare_at (i.e. not on sale).
        var subBase = (compareAt && compareAt > basePrice) ? compareAt : basePrice;
        effectivePrice = subBase * (1 - discount / 100);
        subPriceEls.forEach(function(el){ el.textContent = fmt(effectivePrice); });
        // Keep the subscribe strike-through in sync with subBase (RRP when on sale).
        var subWasEls = document.querySelectorAll('.js-sub-was');
        subWasEls.forEach(function(el){ el.textContent = fmt(subBase); });
        if (subDiscountEl) subDiscountEl.textContent = String(Math.round(discount));
      }

      // ATC button always shows the price the customer will actually pay
      // — sub-discounted if subscribe is active, base if one-time.
      currentPriceEls.forEach(function(el){ el.textContent = fmt(effectivePrice); });

      // Compared (struck) price — use the higher of:
      //   • variant.compare_at_price (real RRP or fake compare from Shop metafield), or
      //   • basePrice (so subscribe-mode strikes the one-time price as the "was").
      // Hide when it's not actually higher than the effective price.
      var wasValue = Math.max(compareAt || 0, mode === 'subscribe' ? basePrice : 0);
      wasPriceEls.forEach(function(el){
        if (wasValue > effectivePrice + 0.001) {
          el.textContent = fmt(wasValue);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      // Hidden input — empty for one-time, plan ID for subscribe
      if (hiddenPlan) hiddenPlan.value = planId;

      // Re-compute points (5 pts per €1 spent, rounded down)
      if (pointsEl) pointsEl.textContent = String(Math.floor(effectivePrice * 5));
      // Klarna — three equal instalments
      if (klarnaEl) klarnaEl.textContent = fmt(effectivePrice / 3);
    }

    // Card click — event delegation on the .bb-commit container so listeners
    // survive DOM replacement (Subscriptions app re-inject, cart-add re-render, etc.)
    var commit = form.querySelector('.bb-commit');
    if (commit && !commit.__pdpCommitBound) {
      commit.__pdpCommitBound = true;
      commit.addEventListener('click', function(e){
        var card = e.target.closest && e.target.closest('.card');
        if (!card || !commit.contains(card)) return;
        // Don't intercept clicks on the inner frequency <select> or its options / links
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION' || e.target.tagName === 'A') return;
        // Refresh the live NodeList each click — cards may have been replaced.
        var liveCards = commit.querySelectorAll('.card');
        liveCards.forEach(function(c){ c.classList.remove('on'); });
        card.classList.add('on');
        refresh();
      });
    }

    // Frequency change — delegate on the form so a re-injected <select> still fires refresh.
    if (!form.__pdpFreqBound) {
      form.__pdpFreqBound = true;
      form.addEventListener('change', function(e){
        if (e.target && e.target.id === 'bb-freq') refresh();
      });
    }

    // Initial paint
    refresh();
  })();

  // -----------------------------------------------------------------
  // OKENDO REVIEW CTA → opens Okendo's "Write a review" form.
  // The actual Okendo → Rivo points award happens server-side: Rivo
  // has a native Okendo integration that listens to review-submitted
  // webhooks. All we do here on the frontend is open the form and
  // give the customer a confirmation when the form is submitted.
  // -----------------------------------------------------------------
  var reviewCta = document.getElementById('rivo-review-cta');
  var reviewEarn = document.getElementById('rivo-review-earn');

  function openOkendoReviewForm(e){
    if (e) e.preventDefault();
    // Try Okendo's official APIs first, in order of preference.
    try {
      if (window.okendoReviewsWidget && window.okendoReviewsWidget.openWriteReview) {
        window.okendoReviewsWidget.openWriteReview();
        return;
      }
      if (window.OkendoWidgetClient && window.OkendoWidgetClient.openWriteReview) {
        window.OkendoWidgetClient.openWriteReview();
        return;
      }
      // Fallback — find the Okendo "write review" button rendered by their widget and click it.
      var okeBtn = document.querySelector(
        '[data-oke-reviews-widget-write-review-btn], ' +
        '[data-oke-reviews-modal-write-review-button], ' +
        '.oke-reviews-writeReview-button, ' +
        'button[data-oke-write-review]:not(#rivo-review-cta)'
      );
      if (okeBtn) { okeBtn.click(); return; }
    } catch (err) { /* swallow — fall through to scroll */ }
    // Last resort — scroll to the reviews grid so the user can find Okendo's own CTA.
    var revs = document.querySelector('.reviews-grid');
    if (revs) revs.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (reviewCta) reviewCta.addEventListener('click', openOkendoReviewForm);
  // Any element marked data-open-okendo on the page can also trigger the form
  // (e.g. the "Write a review" link beside the buy-box stars).
  document.querySelectorAll('[data-open-okendo]').forEach(function(el){
    if (el !== reviewCta) el.addEventListener('click', openOkendoReviewForm);
  });

  // Auto-open Okendo when arriving with ?openReview=1 (e.g. from the rewards
  // page card or the post-purchase order-status page).
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('openReview') === '1') {
      // Wait briefly for Okendo's widget to mount, then open the form.
      var tries = 0, max = 20;
      var timer = setInterval(function(){
        tries++;
        var okeReady =
          (window.okendoReviewsWidget && window.okendoReviewsWidget.openWriteReview) ||
          (window.OkendoWidgetClient && window.OkendoWidgetClient.openWriteReview) ||
          document.querySelector('[data-oke-reviews-widget-write-review-btn], .oke-reviews-writeReview-button');
        if (okeReady || tries >= max) {
          clearInterval(timer);
          openOkendoReviewForm();
        }
      }, 350);
    }
  } catch(e){ /* swallow */ }

  // Mark the callout as "submitted" once Okendo confirms a review has been left.
  // Okendo fires a few different event names depending on widget version — handle them all.
  function markReviewSubmitted(){
    if (!reviewEarn) return;
    reviewEarn.classList.add('is-done');
    var lbl  = reviewEarn.querySelector('.copy .lbl');
    var body = reviewEarn.querySelector('.copy');
    var cta  = reviewEarn.querySelector('.cta');
    if (lbl)  lbl.textContent = '✓ Review submitted';
    if (body) body.innerHTML =
      '<span class="lbl">✓ Review submitted</span>' +
      'Thanks for sharing your skin story. Your <strong>250–500 points</strong> will appear in your account once your review is verified.';
    if (cta) cta.style.display = 'none';
  }

  ['okendo-review-submitted', 'okeReviewSubmitted', 'oke:reviews:submitted'].forEach(function (name) {
    window.addEventListener(name, markReviewSubmitted);
    document.addEventListener(name, markReviewSubmitted);
  });
  // postMessage fallback (some Okendo widgets post to parent when the modal submits)
  window.addEventListener('message', function (e) {
    var d = e && e.data;
    if (!d) return;
    var hit =
      (typeof d === 'string' && /okendo[:\-_]review[:\-_]submitted|okeReviewSubmitted/i.test(d)) ||
      (typeof d === 'object' && (
        d.type === 'okendo-review-submitted' ||
        d.event === 'okeReviewSubmitted' ||
        (d.namespace === 'okendo' && d.action === 'review-submitted')
      ));
    if (hit) markReviewSubmitted();
  });
})();


/* ============================================================
   HOW-TO-USE — small interactions for the v2 layout:
     • AM/PM toggle in the section header (visual state only;
       you can hook it to swap step copy if AM and PM differ)
     • Glow-picker tile selection (single-select; .on class)
   ============================================================ */
(function(){
  // AM / PM toggle — flips the section's data-mode, which the CSS uses to
  // show the matching <ol class="ritual-steps am|pm">. The toggle itself
  // is hidden by CSS when data-has is "am-only" or "pm-only".
  document.querySelectorAll('.s-13').forEach(function(section){
    var wrap = section.querySelector('.ampm-toggle');
    if (!wrap) return;
    var btns = wrap.querySelectorAll('button');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var mode = b.dataset.mode || b.textContent.trim().toLowerCase();
        btns.forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        section.setAttribute('data-mode', mode);
        document.dispatchEvent(new CustomEvent('pm:howto:mode', { detail: { mode: mode } }));
      });
    });
  });

  // Glow-tile picker — single selection, hover/click to highlight
  document.querySelectorAll('.s-13 .glow-tiles').forEach(function(grid){
    var tiles = grid.querySelectorAll('.g-tile');
    tiles.forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        tiles.forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        document.dispatchEvent(new CustomEvent('pm:howto:glow', { detail: { level: t.dataset.glowLevel } }));
      });
    });
  });
})();

/* ============================================================
   BUNDLE / ROUTINE TOTAL — recalculates the displayed total from
   each tile's data-price attribute. In production, the Liquid
   template already prints the correct sum, so this is a no-op
   unless data-price values are present. For the static mockup
   it keeps the price honest if a designer swaps a tile.
   ============================================================ */
(function(){
  function recalc(sectionSel, totalSel){
    var section = document.querySelector(sectionSel);
    if (!section) return;
    var totalEl = section.querySelector(totalSel);
    if (!totalEl) return;
    /* Only run if a dedicated "now" element exists (so we don't blow
       away the <span class="was"> strikethrough). When the new
       structured markup isn't present, leave the Liquid output alone —
       it's already rendered with the shop's currency. */
    var nowEl = totalEl.querySelector('[data-bundle-total-now], .now');
    if (!nowEl) return;
    var tiles = section.querySelectorAll('[data-bundle-tile]');
    if (!tiles.length) return;
    var sum = 0, any = false;
    tiles.forEach(function(t){
      var v = parseFloat(t.dataset.price || '');
      if (!isNaN(v)) { sum += v; any = true; }
    });
    if (!any) return;
    /* Reuse the existing currency symbol from the rendered text so we
       don't hardcode €. Falls back to whatever Shopify rendered. */
    var existing = nowEl.textContent.trim();
    var sym = existing.match(/^[^0-9\-+.,]*/);
    var prefix = (sym && sym[0]) || '';
    nowEl.textContent = prefix + sum.toFixed(2);
  }
  recalc('#sec-15', '[data-bundle-total]');
})();

/* ============================================================
   BULK ADD-TO-CART — wired to both:
     [data-add-routine]  (custom.routine_product)
     [data-add-bundle]   (custom.bundles_product)

   On click:
     1.  Build the line-item array from data-variant-ids
         (Liquid hands them in via `data-variant-ids="123,456,…"`).
     2.  POST to /cart/add.js once with all items in `items[]` —
         Shopify's bulk-add endpoint handles the full set in
         a single round-trip.
     3.  On success, dispatch `pm:cart-drawer:open` for the theme
         to listen to. Most themes (Dawn, Impulse, Pestle's v4)
         open the drawer from this event. As a fallback we also
         call window.PMCart.open() if a global cart controller
         is exposed.
     4.  Show a small bottom-right toast confirming the add. The
         toast is mockup-only — in production the cart drawer
         itself is the confirmation surface.

   In the local mockup (no /cart/add.js endpoint), the fetch
   throws — we catch it and still show the toast so the
   interaction is visible in the static preview.
   ============================================================ */
(function(){
  var buttons = document.querySelectorAll('[data-add-routine], [data-add-bundle]');
  if (!buttons.length) return;

  function toast(msg){
    var t = document.querySelector('.pm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pm-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function(){ t.classList.add('show'); });
    clearTimeout(t._h);
    t._h = setTimeout(function(){ t.classList.remove('show'); }, 2400);
  }

  function openCartDrawer(){
    document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
    if (window.PMCart && typeof window.PMCart.open === 'function') window.PMCart.open();
  }

  buttons.forEach(function(btn){
    var noun = btn.hasAttribute('data-add-bundle') ? 'Bundle' : 'Routine';

    btn.addEventListener('click', function(e){
      e.preventDefault();
      // Accept either data-variant-ids (plural, legacy) or data-variant-id (singular, new bundle-as-cart-product pattern)
      var idsAttr = btn.dataset.variantIds || btn.dataset.variantId || '';
      var ids = idsAttr.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
      if (!ids.length) { toast(noun + ' is empty'); return; }

      btn.disabled = true;
      var original = btn.innerHTML;
      btn.innerHTML = 'Adding…';

      var items = ids.map(function(id){ return { id: id, quantity: 1 }; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res){ return res.ok ? res.json() : Promise.reject(res); })
      .then(function(){
        btn.classList.add('is-added');
        toast(noun + ' added — ' + ids.length + ' items in your bag');
        openCartDrawer();
      })
      .catch(function(){
        // Mockup / dev fallback — endpoint unavailable in static preview
        btn.classList.add('is-added');
        toast(noun + ' added — ' + ids.length + ' items in your bag');
        openCartDrawer();
      })
      .then(function(){
        btn.disabled = false;
        btn.innerHTML = original;
      });
    });
  });
})();

/* Cart drawer bridge — listens for pm:cart-drawer:open and opens the existing P&M drawer. */
(function(){
  document.addEventListener('pm:cart-drawer:open', function(){
    try { if (typeof cart !== 'undefined' && typeof cart.refresh === 'function') cart.refresh(); } catch(e){}
    var d = document.getElementById('cart-drawer');
    if (d) d.classList.add('active');
  });
})();


/* ============================================================
   HEADER CART BUTTON — wires #cart-button click to open the
   cart drawer. Normally provided by product.min.js / scripts.min.js
   which the pdp-v2 template doesn't load. Drawer contents are
   server-rendered into snippets/cart-drawer.liquid at page load.
   ============================================================ */
(function(){
  var btn = document.getElementById('cart-button');
  if (!btn) return;
  btn.addEventListener('click', function(e){
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
  });
})();

/* ============================================================
   BUY-BOX ATC — intercept #bb-form submission so it POSTs to
   /cart/add.js (AJAX, no /cart redirect), then opens the cart
   drawer via the pm:cart-drawer:open bridge.
   ============================================================ */
(function(){
  var form = document.getElementById('bb-form');
  if (!form) return;

  // Flag flipped ON only by a genuine user click on the .bb-atc button (capture
  // phase so we win before any third-party listeners). The submit handler
  // below refuses to run unless this flag is set — blocking essential-upsell
  // and similar apps that reuse our #bb-form to sneak an extra GWP auto-add
  // (Hydrate) into their cart operations. Cleared immediately after each real
  // submit so a single click never triggers more than one add.
  var trustedAtcClickArmed = false;
  var atcBtn = form.querySelector('.bb-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function(evt){
      if (evt.isTrusted) trustedAtcClickArmed = true;
    }, true);
  }
  /* The sticky ATC bar (sections/pdp-v2-sticky-atc.liquid) is our own
     surface — a genuine user click on it should also arm the flag so the
     submit handler below runs. Without this hook, the sticky bar's
     `form.requestSubmit()` call fires a submit event that the guard
     silently drops. */
  document.addEventListener('click', function(evt){
    if (!evt.isTrusted || !evt.target || !evt.target.closest) return;
    if (evt.target.closest('[data-sticky-atc]')) trustedAtcClickArmed = true;
  }, true);

  form.addEventListener('submit', function(e){
    e.preventDefault();

    if (!trustedAtcClickArmed) return;
    trustedAtcClickArmed = false;

    var btn = form.querySelector('.bb-atc');
    if (btn && btn.disabled) return;
    var originalHTML = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="bb-atc-label">Adding…</span>'; }

    /* ---- BELT-AND-BRACES: re-read picker state right before submit ----
       Guarantees the hidden #current-plan input reflects whatever card is
       currently active. Without this, a race condition where the picker's
       initial refresh() hasn't run yet (or a stale value from a previous
       toggle) could leave the input empty and the item adds as one-time. */
    var hiddenPlanEl = document.getElementById('current-plan');
    var subCardEl = form.querySelector('.bb-commit .card.on[data-mode="subscribe"]');
    var freqSelEl = document.getElementById('bb-freq');
    if (hiddenPlanEl) {
      if (subCardEl && freqSelEl && freqSelEl.value) {
        hiddenPlanEl.value = freqSelEl.value;
      } else {
        hiddenPlanEl.value = '';
      }
    }
    console.log('[pdp-v2 ATC] subscribe card active?', !!subCardEl,
                '— selling_plan hidden value:', hiddenPlanEl ? hiddenPlanEl.value : 'NO INPUT');

    var fd = new FormData(form);
    console.log('[pdp-v2 ATC] FormData selling_plan:', fd.get('selling_plan'),
                '— variant id:', fd.get('id'), '— qty:', fd.get('quantity'));
    /* Strip empty selling_plan so Shopify treats it as one-time */
    if (fd.get('selling_plan') === '') fd.delete('selling_plan');

    /* Use the items[] JSON path whenever:
         a) GWP auto-add is in play (button has data-auto-add-id), OR
         b) a selling_plan is set (subscribe & save).
       The JSON path is the documented Shopify Ajax cart format for
       multi-item / selling-plan adds and is more reliable than
       FormData when selling_plan is involved — some app proxies and
       middleware strip unknown form fields but pass the JSON body
       through untouched. */
    var autoAddId = btn ? btn.dataset.autoAddId : null;
    var gwpFunnelId = btn ? btn.dataset.gwpFunnelId : null;
    var sellingPlan = fd.get('selling_plan');
    /* Routine-upsell bundle — if the merchant configured custom.routine_upsell
       and the customer ticked the bundle checkbox, include that variant too. */
    var bundleCheckbox = form.querySelector('.bb-ru-checkbox:not(.bb-ru-multi-checkbox)');
    var bundleVariantId = (bundleCheckbox && bundleCheckbox.checked)
      ? parseInt(bundleCheckbox.getAttribute('data-bundle-variant-id'), 10)
      : null;
    /* PDP Routines section — the checkbox list (.bb-ru-multi-checkbox) lives
       OUTSIDE this form, so gather from the document scope. Any ticked row
       becomes an additional bundle item added alongside the main product. */
    var multiChecked = document.querySelectorAll('.bb-ru-multi-checkbox:checked');

    var useJsonPath = !!autoAddId || (sellingPlan && sellingPlan !== '') || !!bundleVariantId || multiChecked.length > 0;
    var fetchOpts;
    if (useJsonPath) {
      var mainId = parseInt(fd.get('id'), 10);
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      var mainItem = { id: mainId, quantity: qty };
      if (sellingPlan) mainItem.selling_plan = parseInt(sellingPlan, 10);
      /* Carry any properties[...] hidden inputs from the form into the JSON
         items[] path — the FormData path picks these up natively, but the
         JSON path builds each item from scratch, so we have to re-attach.
         Currently used for Essential Upsell trigger properties
         (__essential_upsell_funnel_id / __essential_upsell_product_id)
         set from product.metafields.custom.essential_upsell_funnel_id. */
      var mainProps = {};
      form.querySelectorAll('input[name^="properties["]').forEach(function (inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value) mainProps[m[1]] = inp.value;
      });
      if (Object.keys(mainProps).length) mainItem.properties = mainProps;
      var items = [mainItem];
      if (autoAddId) {
        /* autoAddId may be a single variant id or a comma-separated list
           when the parent product has multiple GWPs (list.product_reference
           metafield). One line item per id. Allow same-SKU BOGO — Shopify
           keeps the two as separate lines because the free line has the
           _gwp_parent_id property and the paid line does not.
           gwpFunnelId (from the trigger product's custom.gwp_funnel_id)
           piggybacks onto every free line as __essential_upsell_funnel_id
           so Essential Upsell applies its free-gift discount per line. */
        String(autoAddId).split(',').forEach(function(rawId){
          var trimmed = rawId.trim();
          if (!trimmed) return;
          var gwpId = parseInt(trimmed, 10);
          if (!gwpId) return;
          var gwpProps = { _gwp_parent_id: String(mainId) };
          if (gwpFunnelId) gwpProps.__essential_upsell_funnel_id = gwpFunnelId;
          items.push({ id: gwpId, quantity: qty, properties: gwpProps });
        });
      }
      if (bundleVariantId && bundleVariantId !== mainId) {
        // Tag the routine upsell with:
        //  - _gwp_parent_id: cart cascade in pm-cart-v3.js removes this line
        //    automatically when the parent product is removed.
        //  - __essential_upsell_funnel_id / __essential_upsell_product_id: piggyback
        //    on the Essential Upsell Shopify Function so it applies the line-item
        //    discount automatically (no discount code needed at checkout).
        var ruPanelForProps = document.querySelector('.bb-routine-upsell');
        var euFunnel  = ruPanelForProps && ruPanelForProps.getAttribute('data-ru-eu-funnel-id');
        var euProduct = ruPanelForProps && ruPanelForProps.getAttribute('data-ru-eu-product-id');
        var bundleProps = { _gwp_parent_id: String(mainId) };
        if (euFunnel)  bundleProps['__essential_upsell_funnel_id']  = euFunnel;
        if (euProduct) bundleProps['__essential_upsell_product_id'] = euProduct;
        items.push({ id: bundleVariantId, quantity: 1, properties: bundleProps });
      }
      /* Any PDP Routines multi-checkboxes ticked — each becomes its own line
         with the same cascade + EU trigger props read from data attributes
         on the checkbox itself (per-routine funnel/product overrides). */
      for (var mi = 0; mi < multiChecked.length; mi++) {
        var mBox = multiChecked[mi];
        var mVid = parseInt(mBox.getAttribute('data-bundle-variant-id'), 10);
        if (!mVid || mVid === mainId) continue;
        var mProps = { _gwp_parent_id: String(mainId) };
        var mFunnel  = mBox.getAttribute('data-eu-funnel-id');
        var mProduct = mBox.getAttribute('data-eu-product-id');
        if (mFunnel)  mProps['__essential_upsell_funnel_id']  = mFunnel;
        if (mProduct) mProps['__essential_upsell_product_id'] = mProduct;
        items.push({ id: mVid, quantity: 1, properties: mProps });
      }
      console.log('[pdp-v2 ATC] using JSON items[] path:', items);
      fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      };
    } else {
      console.log('[pdp-v2 ATC] using FormData path (one-time)');
      fetchOpts = {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      };
    }

    fetch('/cart/add.js', fetchOpts)
    .then(function(res){
      if (!res.ok) return res.json().then(function(err){ return Promise.reject(err); });
      return res.json();
    })
    .then(function(){
      /* Routine-upsell discount code is now applied at CHECKOUT-CLICK TIME
         (see cart-drawer-footer.liquid), not here — the checkout interceptor
         checks the live cart and only appends ?discount=<code> if a routine
         upsell (item tagged _gwp_parent_id) is still present. That way, if
         the customer removes the parent routine the discount cleanly drops. */
      /* Refresh drawer contents if the theme's cart object is available */
      if (typeof cart !== 'undefined' && typeof cart.refresh === 'function') {
        try { cart.refresh(); } catch(e){}
      }
      /* BOGO reminder modal — when this PDP has a matching bogo_reminder_rule
         metaobject, sections/pdp-v2-hero.liquid renders #pnm-bogo-modal in
         the DOM (hidden). Show it in place of opening the cart drawer so
         the customer sees the "we'll email you Friday" message instead of
         the cart. Bail out of the drawer-open path entirely. */
      var bogoModal = document.getElementById('pnm-bogo-modal');
      if (bogoModal) {
        bogoModal.removeAttribute('hidden');
        document.body.classList.add('pnm-bogo-open');
        try {
          var firstInput = bogoModal.querySelector('input[type="email"]');
          if (firstInput) firstInput.focus();
        } catch (e) {}
        return;
      }
      /* PDP Routines picker present? Do a full page reload so the CTA total,
         checkbox state, and routine list all rebuild fresh — otherwise the
         picker keeps stale state across navigations. Flag the cart drawer
         to reopen after reload via sessionStorage, so the customer still
         lands on their bag. */
      if (document.querySelector('.bb-pdp-routines')) {
        try { sessionStorage.setItem('pnm_open_cart_on_load', '1'); } catch (e) {}
        window.location.reload();
        return;
      }
      document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
    })
    .catch(function(err){
      var msg = (err && err.description) || (err && err.message) || 'Add to cart failed';
      try { window.alert(msg); } catch(e){}
    })
    .then(function(){
      if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
    });
  });
})();

/* ============================================================
   ROUTINE UPSELL — bundle checkbox toggle. When checked, swap the
   ATC price to the combined-discount total from data attributes
   on .bb-routine-upsell. When unchecked, restore the original.
   ============================================================ */
(function () {
  var panel = document.querySelector('.bb-routine-upsell:not(.bb-routine-upsell--multi)');
  if (!panel) return;
  var checkbox = panel.querySelector('.bb-ru-checkbox:not(.bb-ru-multi-checkbox)');
  var currentPriceEl = document.querySelector('.bb-atc .bb-atc-price');
  var wasPriceEl = document.querySelector('.bb-atc .bb-atc-price-was');
  if (!checkbox || !currentPriceEl) return;

  var symbol = (document.body.getAttribute('data-currency-symbol') || '€');
  var origCurrent = currentPriceEl.textContent;
  var origWas = wasPriceEl ? wasPriceEl.textContent : '';
  var origWasHidden = wasPriceEl ? wasPriceEl.hasAttribute('hidden') : true;
  var pointsEl = document.querySelector('.js-points');
  var origPoints = pointsEl ? pointsEl.textContent : '';

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    var s = n.toFixed(2);
    return symbol + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  checkbox.addEventListener('change', function () {
    // Re-read data-ru-* on each change so a client-side product swap
    // (e.g. the PDP step-choice chooser) that rewrites those attributes
    // takes effect without a page reload.
    var combinedCents = parseInt(panel.getAttribute('data-ru-combined'), 10) || 0;
    var combinedFinalCents = parseInt(panel.getAttribute('data-ru-combined-final'), 10) || 0;

    if (checkbox.checked) {
      // Same-event live read of the current ATC price so a step-choice swap
      // that happened WHILE the box was already checked becomes the new
      // "origCurrent" we restore to on uncheck.
      origCurrent = currentPriceEl.textContent;
      if (wasPriceEl) {
        origWas = wasPriceEl.textContent;
        origWasHidden = wasPriceEl.hasAttribute('hidden');
      }
      if (pointsEl) origPoints = pointsEl.textContent;

      currentPriceEl.textContent = money(combinedFinalCents);
      if (wasPriceEl) {
        wasPriceEl.textContent = money(combinedCents);
        wasPriceEl.removeAttribute('hidden');
      }
      if (pointsEl) {
        // Points earned = 5 pts per €1 spent (matches the base points formula
        // in refresh() above). Recompute against the discounted combined total
        // so ticking the bundle bumps the P&M points shown to the customer.
        var euros = combinedFinalCents / 100;
        pointsEl.textContent = String(Math.floor(euros * 5));
      }
    } else {
      // Prefer live state from the step-choice chooser (if present on the page).
      // The currently-selected card is the single source of truth for the swapped
      // product's base price + compare — more reliable than the captured
      // origCurrent, which can go stale across sequence (swap → tick → swap → untick).
      var activeCsCard = document.querySelector('[data-bb-step-choice] [data-cs-card].is-selected');
      if (activeCsCard) {
        currentPriceEl.textContent = activeCsCard.dataset.csPriceMoney || origCurrent;
        if (wasPriceEl) {
          var csCmp = activeCsCard.dataset.csCompareMoney;
          if (csCmp) {
            wasPriceEl.textContent = csCmp;
            wasPriceEl.removeAttribute('hidden');
          } else {
            wasPriceEl.textContent = '';
            wasPriceEl.setAttribute('hidden', '');
          }
        }
        if (pointsEl) {
          var csCents = parseInt(activeCsCard.dataset.csPriceCents, 10) || 0;
          pointsEl.textContent = String(Math.floor((csCents / 100) * 5));
        }
      } else {
        // No chooser on this page — restore the original page-load values.
        currentPriceEl.textContent = origCurrent;
        if (wasPriceEl) {
          wasPriceEl.textContent = origWas;
          if (origWasHidden) wasPriceEl.setAttribute('hidden', ''); else wasPriceEl.removeAttribute('hidden');
        }
        if (pointsEl) pointsEl.textContent = origPoints;
      }
    }
  });
})();

/* ============================================================
   PDP ROUTINES PICKER — multi-checkbox ATC price updater. When any
   .bb-ru-multi-checkbox is toggled, sums the base product price with
   the "add" price of every currently-checked row (data-add-price) and
   updates the ATC current + was displays. Restores originals when all
   checkboxes are cleared.
   ============================================================ */
(function () {
  var boxes = document.querySelectorAll('.bb-ru-multi-checkbox');
  if (!boxes.length) return;
  var container = document.querySelector('.bb-pdp-routines');
  var currentPriceEl = document.querySelector('.bb-atc .bb-atc-price');
  var wasPriceEl = document.querySelector('.bb-atc .bb-atc-price-was');
  if (!currentPriceEl) return;

  var symbol = (document.body.getAttribute('data-currency-symbol') || '€');
  var origCurrent = currentPriceEl.textContent;
  var origWas = wasPriceEl ? wasPriceEl.textContent : '';
  var origWasHidden = wasPriceEl ? wasPriceEl.hasAttribute('hidden') : true;
  var baseDiscountPct = container ? (parseInt(container.getAttribute('data-base-discount-pct'), 10) || 0) : 0;

  function parseMoney(str) {
    var num = String(str || '').replace(/[^0-9.]/g, '');
    var f = parseFloat(num);
    return isNaN(f) ? 0 : Math.round(f * 100);
  }
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return symbol + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var baseCurrentOrig = parseMoney(origCurrent);
  var baseWasOrig = origWas ? parseMoney(origWas) : baseCurrentOrig;

  /* P&M points row — same 5-pts-per-currency formula as the single
     routine upsell handler above. Each tick on a multi-routine
     checkbox recalculates points off the summed current total so the
     "+ EARN X P&M POINTS" display stays in sync with the ATC price. */
  var pointsEl = document.querySelector('.js-points');
  var origPoints = pointsEl ? pointsEl.textContent : '';

  /* Free-shipping meter under the ATC — updates in step with the picker. */
  var shipBar = document.querySelector('.bb-ship-bar');
  var shipThreshold = shipBar ? (parseInt(shipBar.getAttribute('data-threshold-cents'), 10) || 0) : 0;
  var shipBaseCents = shipBar ? (parseInt(shipBar.getAttribute('data-base-cents'), 10) || 0) : 0;
  var shipDiffEl = shipBar ? shipBar.querySelector('.target-difference') : null;
  var shipBarEl  = shipBar ? shipBar.querySelector('.progress-bar .bar') : null;
  var shipQualWrap = shipBar ? shipBar.querySelector('.cart-qualification') : null;

  function updateShipBar(cartCents) {
    if (!shipBar || !shipThreshold) return;
    var pct = cartCents >= shipThreshold ? 100 : Math.floor(cartCents * 100 / shipThreshold);
    if (shipBarEl) shipBarEl.style.width = pct + '%';
    if (cartCents >= shipThreshold) {
      if (shipQualWrap) shipQualWrap.classList.add('qualified');
    } else {
      if (shipQualWrap) shipQualWrap.classList.remove('qualified');
      if (shipDiffEl) shipDiffEl.textContent = money(shipThreshold - cartCents);
    }
  }

  function update() {
    var anyChecked = false;
    var addCurrent = 0;
    var addWas = 0;
    Array.prototype.forEach.call(boxes, function (cb) {
      if (!cb.checked) return;
      anyChecked = true;
      addCurrent += parseInt(cb.getAttribute('data-add-price'), 10) || 0;
      addWas     += parseInt(cb.getAttribute('data-was-price'), 10) || 0;
    });
    /* When any routine is ticked, apply the metaobject rule's discount %
       (e.g. 30% off DCS) to the BASE product's ORIGINAL price so the CTA
       total reflects the bundle deal. If DCS PDP shows €81 with €90
       strikethrough, we discount off €90 (baseOriginal), not €81. */
    var baseOriginal = (baseWasOrig > baseCurrentOrig) ? baseWasOrig : baseCurrentOrig;
    var baseCurrent = baseCurrentOrig;
    if (anyChecked && baseDiscountPct > 0) {
      baseCurrent = Math.round(baseOriginal * (100 - baseDiscountPct) / 100);
    }
    var sumCurrent;
    if (anyChecked) {
      sumCurrent = baseCurrent + addCurrent;
      var sumWas = baseOriginal + addWas;
      currentPriceEl.textContent = money(sumCurrent);
      if (wasPriceEl && sumWas > sumCurrent) {
        wasPriceEl.textContent = money(sumWas);
        wasPriceEl.removeAttribute('hidden');
      } else if (wasPriceEl) {
        wasPriceEl.setAttribute('hidden', '');
      }
    } else {
      sumCurrent = shipBaseCents || baseCurrentOrig;
      currentPriceEl.textContent = origCurrent;
      if (wasPriceEl) {
        wasPriceEl.textContent = origWas;
        if (origWasHidden) wasPriceEl.setAttribute('hidden', ''); else wasPriceEl.removeAttribute('hidden');
      }
    }
    if (pointsEl) {
      pointsEl.textContent = anyChecked
        ? String(Math.floor((sumCurrent / 100) * 5))
        : origPoints;
    }
    updateShipBar(sumCurrent);
  }

  Array.prototype.forEach.call(boxes, function (cb) {
    cb.addEventListener('change', update);
  });
})();

/* ============================================================
   FULL TRANSPARENCY accordions (.s-20) — click a row to toggle
   its .open state, revealing the .acc-body beneath it.
   ============================================================ */
(function(){
  var section = document.getElementById('sec-20');
  if (!section) return;
  section.addEventListener('click', function(e){
    var row = e.target.closest('.acc-row');
    if (!row) return;
    var item = row.parentElement;
    if (!item || !item.classList.contains('acc')) return;
    item.classList.toggle('open');
  });
})();

/* ============================================================
   FAQ accordions (.s-19) — click a row to toggle .open and
   reveal the answer beneath the question.
   ============================================================ */
(function(){
  var section = document.getElementById('sec-19');
  if (!section) return;
  section.addEventListener('click', function(e){
    var item = e.target.closest('.faq');
    if (!item || !section.contains(item)) return;
    item.classList.toggle('open');
  });
})();


/* ============================================================
   Before / After slider + week-tab toggle (.s-ba)
   ============================================================ */
(function(){
  var section = document.getElementById('sec-ba');
  if (!section) return;
  var wrap = section.querySelector('#ba-wrap') || section.querySelector('.ba-wrap');
  var handle = section.querySelector('#ba-handle') || section.querySelector('.ba-handle');
  var after = section.querySelector('#ba-after') || section.querySelector('.ba-img.after');
  var afterTag = section.querySelector('#ba-after-tag');
  var wkLabel = section.querySelector('#ba-wk-label');
  var wkScale = section.querySelector('#ba-wk-scale');
  var weekBtns = section.querySelectorAll('.ba-weeks button');
  if (!wrap || !handle || !after) return;

  var dragging = false;
  function setPos(x){
    var rect = wrap.getBoundingClientRect();
    var pct = Math.max(2, Math.min(98, ((x - rect.left) / rect.width) * 100));
    handle.style.left = pct + '%';
    after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
  }
  handle.addEventListener('pointerdown', function(e){ dragging = true; e.preventDefault(); });
  window.addEventListener('pointerup', function(){ dragging = false; });
  window.addEventListener('pointermove', function(e){ if (dragging) setPos(e.clientX); });
  wrap.addEventListener('pointerdown', function(e){ if (e.target !== handle) setPos(e.clientX); });

  function setWeek(wk){
    after.setAttribute('data-wk', wk);
    if (wkLabel)  wkLabel.textContent  = 'Week ' + wk;
    if (afterTag) afterTag.textContent = 'After · Week ' + wk;
    if (wkScale)  wkScale.textContent  = 'Week ' + wk;
    var img = '';
    weekBtns.forEach(function(b){
      var on = b.dataset.wk === String(wk);
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) img = b.dataset.image || '';
    });
    if (img) {
      after.style.backgroundImage = "url('" + img + "')";
      after.style.backgroundSize = 'cover';
      after.style.backgroundPosition = 'center';
    }
    handle.style.left = '50%';
    after.style.clipPath = 'inset(0 0 0 50%)';
  }
  weekBtns.forEach(function(b){
    b.addEventListener('click', function(){ setWeek(b.dataset.wk); });
  });
})();

/* ============================================================
   Press Quote Rotator (.s-pressrot)
   ============================================================ */
(function(){
  var section = document.getElementById('sec-pressrot');
  if (!section) return;
  var slides = section.querySelectorAll('.quote-slide');
  var dots   = section.querySelectorAll('.dots button');
  if (slides.length < 2) return;
  var i = 0;
  function paint(){
    slides.forEach(function(s, idx){ s.classList.toggle('active', idx === i); });
    dots.forEach(function(d, idx){ d.classList.toggle('on', idx === i); });
  }
  dots.forEach(function(d){
    d.addEventListener('click', function(){ i = parseInt(d.dataset.i, 10) || 0; paint(); });
  });
  setInterval(function(){ i = (i + 1) % slides.length; paint(); }, 6000);
})();

/* ============================================================
   BOGO REMINDER MODAL — email capture on ATC for eligible PDPs.
   The modal markup is rendered by snippets/pnm-bogo-reminder-modal.liquid
   when the current product matches a bogo_reminder_rule metaobject
   entry. The ATC handler above shows it in place of the cart drawer.
   Here we wire close, submit, and the Klaviyo client subscription API.
   ============================================================ */
(function () {
  var modal = document.getElementById('pnm-bogo-modal');
  if (!modal) return;

  var KLAVIYO_COMPANY_ID = 'YdCHYf';
  var listId = modal.getAttribute('data-klaviyo-list') || '';
  var productTitle = modal.getAttribute('data-product-title') || '';
  var form    = modal.querySelector('[data-bogo-form]');
  var errorEl = modal.querySelector('[data-bogo-error]');
  var success = modal.querySelector('[data-bogo-success]');
  var submitBtn = form ? form.querySelector('button[type="submit"]') : null;

  function close() {
    modal.setAttribute('hidden', '');
    document.body.classList.remove('pnm-bogo-open');
  }

  Array.prototype.forEach.call(modal.querySelectorAll('[data-bogo-close]'), function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
  });

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (form.querySelector('input[type="email"]').value || '').trim();
    if (!email || email.indexOf('@') === -1) {
      if (errorEl) { errorEl.textContent = 'Please enter a valid email.'; errorEl.removeAttribute('hidden'); }
      return;
    }
    if (errorEl) errorEl.setAttribute('hidden', '');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }

    if (!listId) {
      /* No Klaviyo list configured yet — still show the success state so
         the merchant can preview the flow. Merchant fills in the list ID
         on the metaobject when the Klaviyo list is ready. */
      form.setAttribute('hidden', '');
      if (success) success.removeAttribute('hidden');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
      return;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { bogo_product: productTitle }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      /* Klaviyo returns 202 on accept — treat any 2xx as success. */
      if (res.status >= 200 && res.status < 300) {
        form.setAttribute('hidden', '');
        if (success) success.removeAttribute('hidden');
      } else {
        return res.text().then(function (t) { return Promise.reject(new Error(t || 'Subscribe failed')); });
      }
    })
    .catch(function () {
      if (errorEl) { errorEl.textContent = 'Something went wrong. Please try again.'; errorEl.removeAttribute('hidden'); }
    })
    .then(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
    });
  });
})();
